/**
 * Implementation from
 *
 * https://github.com/cowboy/jquery-tiny-pubsub
 *
 * @return {undefined}
 */
export default function pubSub($) {
    let o = $({});

    $.subscribe = function () {
        o.on.apply(o, arguments);
    };

    $.unsubscribe = function () {
        o.off.apply(o, arguments);
    };

    $.publish = function () {
        o.trigger.apply(o, arguments);
    };
}